/* eslint-disable @typescript-eslint/naming-convention */
export enum EyeshadowType {
	"単色アイシャドー",
	"パレットアイシャドー",
	"その他",
}
